import styled from 'styled-components'

export const SwitchInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
`

export const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 32px;
  height: 16px;
  border-radius: 24px;
  position: relative;
  margin-left: 14px;
  transition: background-color 0.2s;
  background: ${(props) => {
    return props.enable ? '#0AA1F4' : 'rgba(32, 32, 32, 0.2)'
  }} ;
`

export const SwitchButton = styled.span`
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 24px;
  transition: 0.2s;
  background: #FFF;
  box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05);
  ${SwitchInput}:checked + ${SwitchLabel} & {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }

  ${SwitchLabel}:active & {
    width: 12px;
  }
`
